import { chakra, Image, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

const TokenLogoPlaceholder = ({ className }: { className?: string }) => {
  const src = useColorModeValue('/icons/default_token_white.svg', '/icons/default_token.svg');

  return (
    <Image
      className={ className }
      src={ src }
      alt=""
      borderRadius="full"
      transitionProperty="opacity"
      transitionDuration="normal"
      transitionTimingFunction="ease"
    />
  );
};

export default chakra(TokenLogoPlaceholder);
